import React, { CSSProperties, FC } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

import { AdvertiserType } from "../../../../../types/advertiserTypes";

type AdvertiserSelectProps = {
  advertisers: AdvertiserType[];
  value: string;
  onChange: (advertiserId: string) => void;
  className?: string;
  style?: CSSProperties;
};

const AdvertiserSelect: FC<AdvertiserSelectProps> = ({ advertisers, value, onChange, className, style }) => (
  <div className={className} style={{ margin: "3rem 0", width: "20rem", ...style }}>
    <FormControl fullWidth>
      <InputLabel id="advertiser-select-label">Select Advertiser</InputLabel>
      <Select
        labelId="advertiser-select-label"
        id="advertiser-select"
        value={value}
        label="Advertiser"
        onChange={(e) => onChange(e.target.value as string)}
      >
        {advertisers.map((advertiser) => (
          <MenuItem key={advertiser.brandgenAdvertiserId} value={advertiser.brandgenAdvertiserId}>
            {advertiser.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </div>
);

export default AdvertiserSelect;
